import { render, staticRenderFns } from "./FleetClusters.vue?vue&type=template&id=38639ef4&"
import script from "./FleetClusters.vue?vue&type=script&lang=js&"
export * from "./FleetClusters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports